<template>
  <div class="d-flex align-center">
    <!-- 6 Hour Delay Disabled Warning -->
    <v-tooltip v-if="showSixHourDelayWarning" bottom max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="warning"
          size="26"
          class="ms-4"
          style="cursor: pointer"
          v-bind="attrs"
          v-on="on"
          @click="openUserSettings()"
        >
          {{ icons.mdiAlert }}
        </v-icon>
      </template>
      <span
        >The 6 hour delay is disabled for all users. Tickets and charges created within the last 6 hours are being
        included on the contractor balance sheet on the Create Invoice and Report pages.</span
      >
    </v-tooltip>
    <!-- /6 Hour Delay Disabled Warning -->

    <v-menu offset-y left nudge-bottom="14" min-width="230" content-class="user-profile-menu-content">
      <template v-slot:activator="{ on, attrs }">
        <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
          <v-avatar size="40px" v-bind="attrs" color="primary" class="v-avatar-light-bg primary--text" v-on="on">
            <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
          </v-avatar>
        </v-badge>
      </template>
      <v-list>
        <div class="pb-3 pt-2">
          <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
            <v-avatar size="40px" color="primary" class="v-avatar-light-bg primary--text">
              <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
            </v-avatar>
          </v-badge>
          <div class="d-inline-flex flex-column justify-center ms-3" style="vertical-align: middle">
            <span v-if="userData" class="text--primary font-weight-semibold mb-n1"> {{ userData.name }} </span>
            <small class="text--disabled text-capitalize">Admin</small>
          </div>
        </div>

        <!-- <v-divider></v-divider> -->

        <!-- Profile -->
        <!-- <v-list-item>
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiAccountOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- Email -->
        <!-- <v-list-item href="#">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiEmailOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Inbox</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- Chat -->
        <!-- <v-list-item href="#">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiChatOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Chat</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-badge inline color="error" content="2"> </v-badge>
          </v-list-item-action>
        </v-list-item> -->

        <v-divider class="my-2"></v-divider>

        <!-- Settings -->
        <!-- <v-hover v-slot="{ hover }">
          <router-link style="text-decoration: none; color: inherit" to="/settings/settings">
            <v-list-item :style="{ 'background-color': hover ? '#3e3a57' : '' }">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  {{ icons.mdiCogOutline }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Settings</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link></v-hover
        > -->
        <!-- /Settings -->

        <!-- Pricing -->
        <!-- <v-list-item href="#">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiCurrencyUsd }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pricing</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- Switch Company -->
        <v-hover v-slot="{ hover }">
          <router-link style="text-decoration: none; color: inherit" to="/chooseOrg">
            <v-list-item :style="{ 'background-color': hover ? '#3e3a57' : '' }">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  {{ icons.mdiSwapHorizontal }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Switch Company</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-hover>
        <v-divider class="my-2"></v-divider>

        <!-- User Settings -->
        <v-hover v-if="canViewUserSettings" v-slot="{ hover }">
          <v-list-item
            :style="{ 'background-color': hover ? '#3e3a57' : '' }"
            @click="openUserSettings()"
            style="cursor: pointer; text-decoration: none; color: inherit"
          >
            <v-list-item-icon class="me-2">
              <v-icon size="22">
                {{ icons.mdiCog }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-hover>
        <v-divider v-if="canViewUserSettings" class="my-2"></v-divider>

        <!-- Logout -->
        <v-hover v-slot="{ hover }">
          <v-list-item :style="{ 'background-color': hover ? '#3e3a57' : '' }" style="cursor: pointer">
            <v-list-item-icon class="me-2">
              <v-icon size="22">
                {{ icons.mdiLogoutVariant }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title @click="signOut()">Log out</v-list-item-title>
            </v-list-item-content>
          </v-list-item></v-hover
        >
      </v-list>
    </v-menu>

    <!-- USER SETTINGS DIALOG -->
    <v-dialog v-model="userSettingsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="primary">
          <v-btn icon @click="userSettingsDialog = false">
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>General</v-subheader>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="userSettings.overrideLockoutPeriod" @change="updateUserSettings()"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Override Lockout Period</v-list-item-title>
              <v-list-item-subtitle
                >Override the lockout period so you can submit invoices on the 1st, 2nd, or 3rd of the
                month?</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="disableSixHourDelay"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Disable 6 Hour Delay</v-list-item-title>
              <v-list-item-subtitle
                >Show tickets and charges on the contractor balance sheet as soon as they are created instead of waiting
                6 hours. Applies to all users, on the Create Invoice and Report pages.</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
    <!-- /USER SETTINGS DIALOG -->
  </div>
</template>

<script>
import { isAdmin } from '@/js/helpers.js'
import {
  mdiAccountOutline,
  mdiAlert,
  mdiChatOutline,
  mdiCheckboxMarkedOutline,
  mdiClose,
  mdiCog,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiEmailOutline,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiSwapHorizontal,
} from '@mdi/js'
import firebase from 'firebase'

export default {
  data() {
    return {
      userData: null,
      org: null,
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
        mdiSwapHorizontal,
        mdiAlert,
        mdiCog,
        mdiClose,
      },
      userSettingsDialog: false,
      userSettings: {
        overrideLockoutPeriod: false,
      },
    }
  },
  computed: {
    canViewUserSettings() {
      return isAdmin(this.$store.state.userData)
    },

    // App wide setting, so read and write it through the store rather than userSettings.
    disableSixHourDelay: {
      get() {
        return this.$store.state.appSettings.disableSixHourDelay
      },
      set(value) {
        this.updateAppSettings(value)
      },
    },

    // Only the users who can turn the delay back on are warned that it is off.
    showSixHourDelayWarning() {
      return this.canViewUserSettings && this.disableSixHourDelay
    },
  },
  methods: {
    openUserSettings() {
      if (this.canViewUserSettings) {
        this.userSettingsDialog = true
      }
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          // Sign-out successful.
          sessionStorage.clear()
          this.$router.push({ path: '/login' })
        })
        .catch(error => {
          // An error happened.
          console.log(error)
        })
    },
    async updateUserSettings() {
      try {
        // updated user settings in firestore
        await firebase.firestore().doc(`users/${this.userData.uid}`).update({
          settings: this.userSettings,
        })

        // update user settings in store
        let userDataCopy = JSON.parse(JSON.stringify(this.userData))
        userDataCopy['settings'] = this.userSettings
        this.$store.commit('setUserData', userDataCopy)
      } catch (err) {
        console.log(err)
      }
    },
    async updateAppSettings(disableSixHourDelay) {
      const previous = this.$store.state.appSettings.disableSixHourDelay

      // Commit up front so the checkbox responds immediately, then let the listener in main.js
      // confirm it. Roll back if the write fails so the UI doesn't claim a change that never landed.
      this.$store.commit('setAppSettings', { disableSixHourDelay })

      try {
        // set() rather than update() so the doc is created the first time a setting is changed
        await firebase.firestore().doc('appSettings/global').set({ disableSixHourDelay }, { merge: true })
      } catch (err) {
        this.$store.commit('setAppSettings', { disableSixHourDelay: previous })
        console.log(err)
        this.$toasted.show('Error saving setting', {
          duration: null,
          keepOnHover: true,
          type: 'error',
        })
      }
    },
  },
  mounted() {
    this.userData = this.$store.state.userData
    if (this.userData && this.userData.settings) {
      this.userSettings.overrideLockoutPeriod = this.userData.settings.overrideLockoutPeriod || false
    }
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}

// v-badge defaults to inline-block, which leaves baseline descender space below the badged
// notification bell and avatar and lifts them a couple of pixels above the row's centre line.
// Flexing them keeps every app bar icon on the same centre line as the warning icon.
.navbar-content-container {
  .v-badge {
    display: flex;
    align-items: center;
  }
}
</style>
